import {Ng1Controller, StateService, TargetState, Transition} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {DisposeBag} from "../../modules/DisposeBag";
import {DebounceFactory} from "../../modules/DebounceModule";
import {IFilterService} from "angular";
import {UserFullDto} from "../../model/UserFullDto";
import {ConfigService} from "../../modules/ConfigModule";
import {UserDto} from "../../model/UserDto";
import {ngStorage} from "ngstorage";
import StorageService = ngStorage.StorageService;

export default class DashboardController implements Ng1Controller {
    private disposeBag = new DisposeBag();
    private users: UserFullDto[];

    $onInit(): void {
        this.refreshDebounce();
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        this.disposeBag.finalize();
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
        console.debug('uiOnParamsChanged', newValues, $transition$);
        this.$stateParams = newValues;
        this.refreshDebounce();
    }

    constructor(private $dataHub: DataHubService,
                private $debounce: DebounceFactory,
                private $filter: IFilterService,
                private $config: ConfigService,
                private $localStorage: StorageService,
                private $state: StateService, private $stateParams: any) {
        $dataHub.onConnected(this.refreshDebounce, this.disposeBag);
        if (!this.user) this.user = this.$config.userInfo;
    }

    refreshDebounce = this.$debounce(() => this.refresh(), 500, false);

    refresh = () => {
        console.debug('refresh', this.$dataHub.isConnected)
        if (!this.$dataHub.isConnected) return;

        this.$dataHub.userSubscribeAndQuery()
            .then(ret => this.users = ret)
            .catch(this.$dataHub.defaultErrorHandler);
    };

    get user(): UserDto {
        return this.$localStorage.activityDashboardUser;
    }

    set user(value: UserDto) {
        this.$localStorage.activityDashboardUser = value;
    }
}
